/* stylelint-disable max-nesting-depth */

:host {
  uic-tab-list {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    font-size: var(--uic-font-size-normal);
    font-weight: var(--uic-font-weight-bold);
    line-height: var(--uic-line-height-normal);
    position: relative;
    vertical-align: top;

    .uic-tab-list__indicator {
      background-color: var(--uic-tab-indicator-color);
      bottom: 0;
      height: 4px;
      left: 0;
      position: absolute;
      transform-origin: top left;
      transition: transform 0.1s ease-in-out;
      width: 0;
      z-index: 0;
    }

    &[vertical] .uic-tab-list__indicator {
      height: 0;
      top: 0;
      width: 4px;
    }

    &[variant='sub']:not([vertical]) .uic-tab-list__indicator {
      bottom: 0;
      height: 4px;
      width: 0;
    }

    &[variant='content']:not([vertical]) .uic-tab-list__indicator {
      height: 4px;
      top: 0;
      width: 0;
    }

    &[vertical] {
      align-items: normal;
      flex-direction: column;
    }

    &[variant='main'] {
      --uic-tab-text-color: var(--uic-tab-main-text-color);
      --uic-tab-background-color: var(--uic-tab-main-background-color);
      --uic-tab-background-color-hover: var(--uic-tab-main-background-color-hover);
      --uic-tab-text-color-focus: var(--uic-tab-main-text-color-focus);
      --uic-tab-border-color-focus: var(--uic-tab-main-border-color-focus);
      --uic-tab-text-color-active: var(--uic-tab-main-text-color-active);
      --uic-tab-text-color-selected: var(--uic-tab-main-text-color-selected);
    }

    &[variant='sub'] {
      --uic-tab-text-color: var(--uic-tab-sub-text-color);
      --uic-tab-background-color: var(--uic-tab-sub-background-color);
      --uic-tab-background-color-hover: var(--uic-tab-sub-background-color-hover);
      --uic-tab-text-color-focus: var(--uic-tab-sub-text-color-focus);
      --uic-tab-border-color-focus: var(--uic-tab-sub-border-color-focus);
      --uic-tab-text-color-active: var(--uic-tab-sub-text-color-active);
      --uic-tab-text-color-selected: var(--uic-tab-sub-text-color-selected);
      --uic-tab-text-color-disabled: var(--uic-tab-sub-text-color-disabled);
      --uic-tab-background-color-disabled: var(--uic-tab-sub-background-color-disabled);
      background: #000;

      &:not([vertical]) {
        uic-tab {
          border-bottom: 1px solid #000;

          &:not(:last-of-type) {
            border-right: 1px solid #000;
          }

          &[selected] {
            border-bottom: 1px solid transparent;
          }
        }
      }

      &[vertical] {
        uic-tab {
          border-bottom: 1px solid #000;
          border-right: 1px solid #000;

          &[selected] {
            border-right: 1px solid transparent;
          }
        }
      }
    }

    &[variant='content'] {
      --uic-tab-text-color: var(--uic-tab-content-text-color);
      --uic-tab-background-color: var(--uic-tab-content-background-color);
      --uic-tab-background-color-hover: var(--uic-tab-content-background-color-hover);
      --uic-tab-text-color-focus: var(--uic-tab-content-text-color-focus);
      --uic-tab-border-color-focus: var(--uic-tab-content-border-color-focus);
      --uic-tab-text-color-active: var(--uic-tab-content-text-color-active);
      --uic-tab-text-color-selected: var(--uic-tab-content-text-color-selected);
      --uic-tab-text-color-disabled: var(--uic-tab-content-text-color-disabled);
      --uic-tab-background-color-disabled: var(--uic-tab-content-background-color-disabled);
      background: var(--uic-tab-background-color);

      &:not([vertical]) {
        uic-tab {
          border-bottom: 1px solid #fff;
          border-right: 1px solid #fff;

          &[selected] {
            background: #fff;
            border-top: 1px solid transparent;
          }
        }
      }

      &[vertical] {
        uic-tab {
          border-bottom: 1px solid #fff;
          border-right: 1px solid #fff;

          &[selected] {
            background: #fff;
            border-right: 1px solid transparent;
          }
        }
      }
    }
  }
}

/* stylelint-enable max-nesting-depth */
